import $ from 'jquery';
import Swiper from 'swiper/swiper-bundle.min';
import { $window, MIN_DELAY, breakpoint } from '../variables/variables.js';

function debounce( cb ) {
	let timeoutID;

	return () => {
		clearTimeout( timeoutID );
		timeoutID = setTimeout( cb, MIN_DELAY );
	};
}

function createSwiperToggle( selector, condition ) {
	const $swiper = $( `${selector} .swiper` );

	if ( ! $swiper.length ) {
		return;
	}

	const slider = new Swiper( $swiper[0], {
		slidesPerView: 'auto',
		navigation: {
			nextEl: `${selector} .swiper-button-next`,
			prevEl: `${selector} .swiper-button-prev`,
		},
	} );

	function toggle() {
		if ( condition() ) {
			slider.disable();
		} else {
			slider.enable();
		}
	}
	toggle();
	$window.on( 'resizeWidth', debounce( toggle ) );
}

export { debounce, createSwiperToggle };
